import { render, staticRenderFns } from "./advanced.vue?vue&type=template&id=545006d7"
import script from "./advanced.vue?vue&type=script&lang=js"
export * from "./advanced.vue?vue&type=script&lang=js"
import style0 from "./advanced.vue?vue&type=style&index=0&id=545006d7&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports